import React from 'react';
import { Trans } from 'react-i18next';

import AssistantAvatar from '../AssistantAvatar';

import './welcome-message.scss';

const WelcomeMessage = () => (
  <section className="welcome-message">
    <AssistantAvatar typeAvatar="welcome" />
    {/* <section className="welcome-message__result">
      <h3 className="welcome-message__result_title">Resultado pélvico:</h3>
      <p className="welcome-message__result_subtitle">Disfunción pélvica moderada</p>
      <p className="welcome-message__result_rate">High level 9.5</p>
      <p className="welcome-message__result_content">
        <strong>Una disfunsión del suelo pélvico (DSP)</strong> ocurre cuando los músculos de esta zona están débiles,
        tensos o descoordinados.
      </p>
    </section> */}
    <div className="welcome-message__labelcontainer">
      <AssistantAvatar typeAvatar="bubble" />
      <p className="welcome-message__labelcontainer_label">
        <Trans components={{ strong: <strong /> }}>evieApp.assistant.welcomeMessage.label</Trans>
      </p>
    </div>
  </section>
);

export default WelcomeMessage;
